import { ChoiceControlText } from '../models/ai-hub.models';

export const DATA_SOURCE_FLAG = 'core-ai-online-resources-enabled';

export const DATA_SOURCE_TEXT: ChoiceControlText = {
  restrictiveLabelKey: 'iqboost.privacySecurityCenter.maximizerData',
  openLabelKey: 'iqboost.privacySecurityCenter.webData',
  requiredCaptionKey: 'aiHub.general.dataSource.requiredByOrganization',
  chooseCaptionKey: 'aiHub.general.dataSource.chooseForAccount',
};
